// import { apiEleg } from '../../config/api'
import { getWorkshopModule } from '../../config/apiSinToken'

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra las mipymes que tienen pendiente realizar el workshop
 * Fecha: 23-11-2022
 */
export const getPendientesWorkshop = async (idIFI) => {
  const data = await getWorkshopModule(
    `api/v1/WorkShopsPendientes/ListWorkShopsNotificacionesPendientesByIfi/${idIFI}`,
  )
  return data
}
